<template>
  <div class="dn-content-bg bigBox zt">
    <div class="boxtop pabox">
      <span class="title" style="font-size: 22px">任务器配置</span>
      <div class="tobbox">
        <div class="tobboxItem">
          <label class="sum">开始时间</label>
          <el-date-picker
            style="width: 250px"
            v-model="startTime"
            type="date"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy/MM/dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
        <div class="tobboxItem">
          <label class="sum">结束时间</label>
          <el-date-picker
            style="width: 250px"
            v-model="endTime"
            type="date"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy/MM/dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
      </div>
    </div>
    <div class="boxtop pabox">
      <span class="title">用能体检分析参数配置</span>
    </div>
    <div style="display: flex; margin-bottom: 8px; margin-right: 14px">
      <label class="sumOne">报告名称</label>
      <el-input
        clearable
        placeholder="请输入报告名称"
        v-model="baseName"
      ></el-input>
    </div>
    <el-form label-width="100px" :model="form" ref="form" class="pabox">
      <el-form-item label="项目公司名称:" prop="projectName">
        <el-input
          v-model="form.projectName"
          placeholder="请输入"
          autocomplete="off"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="电压等级:">
        <el-input v-model="form.voltageGrade"></el-input>
      </el-form-item>
      <el-form-item label="项目公司名称:">
        <label class="bRight">{{ form.address }}</label>
        <el-button type="primary" size="small" @click="selectDess"
          >选择地址</el-button
        >
      </el-form-item>
      <el-form-item label="变压器数量:" prop="transformerNumber">
        <el-input-number v-model="form.transformerNumber"></el-input-number>
      </el-form-item>
      <el-form-item label="检测点数量:" prop="monitoringStations">
        <el-input-number v-model="form.monitoringStations"></el-input-number>
      </el-form-item>
      <el-form-item label="计量点总点:" prop="measureId">
        <label class="point-name">{{ form.measureName }}</label>
        <label class="btn-point" @click="selectPoint()">选择测量点</label>
      </el-form-item>
      <el-form-item label="变压器列表:" prop="measureId" style="height: 300px">
        <el-button
          style="float: left; margin-bottom: 10px"
          type="primary"
          @click="addPower"
          >新增变压器</el-button
        >
        <div class="top">
          <nk-table
            :data="form.childrenTransformerList"
            :columns="columns"
            :border="true"
            id="table"
            height="100%"
          >
            <el-table-column
              slot="operation"
              label="操作"
              width="150"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="editPowerRow(scope.row, scope.$index)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  @click="removePorweRow(scope.row, scope.$index)"
                  >移除</el-button
                >
              </template>
            </el-table-column>
          </nk-table>
        </div>
      </el-form-item>
      <el-form-item label="部门列表:" prop="measureId" style="height: 300px">
        <el-button
          style="float: left; margin-bottom: 10px"
          type="primary"
          @click="addDe"
          >新增部门列表</el-button
        >
        <div class="top">
          <nk-table
            :data="form.departmentList"
            :columns="columnsDep"
            :showIndex="true"
            :border="true"
            id="table"
            height="100%"
          >
            <el-table-column
              slot="operation"
              label="操作"
              width="200"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="editDeRow(scope.row, scope.$index)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  @click="removeDeRow(scope.row, scope.$index)"
                  >移除</el-button
                >
              </template>
            </el-table-column>
          </nk-table>
        </div>
      </el-form-item>
    </el-form>
    <div class="pabox">
      <el-button @click="savePageAllData" type="success">立即保存</el-button>
      <el-button @click="resetForm">重置</el-button>
    </div>
    <!-- 选择地址 -->
    <el-dialog
      title="选择地址"
      :visible.sync="showDess"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form label-width="150px" :model="newForm" ref="newForm">
        <el-form-item
          label="公司地址:"
          style="margin-bottom: 10px"
          :inline-message="true"
          class="nc"
        >
          <el-cascader
            :props="props"
            :options="options"
            v-model="newForm.address"
            @change="handler"
          ></el-cascader>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 选择测量点 -->
    <el-dialog
      title="请选择树节点(单选)"
      :visible.sync="selectNodeDialog"
      custom-class="dialog"
      :close-on-click-modal="false"
    >
      <div class="dialog-info">
        <div class="view-tree">
          <div
            :class="[
              'view-tree-item',
              index === viewTreeIndex ? 'view-tree-select' : '',
            ]"
            v-for="(item, index) in viewTree"
            :key="index"
            @click="viewTreeClick(item, index)"
          >
            {{ item.displayName }}
          </div>
        </div>
        <div class="dialog-box" style="width: 100%; height: 300px">
          <nk-left-tree
            ref="tree"
            :defaultCurrent="false"
            :data="leftTreeData"
            v-if="leftTreeData.length > 0"
            @click="nodeClick"
          ></nk-left-tree>
        </div>
      </div>
    </el-dialog>
    <!-- 新增变压器,部门 -->
    <el-dialog
      :title="powTitle"
      :visible.sync="powerShow"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form label-width="150px" :model="powerForm">
        <el-form-item label="变压器名称:">
          <el-input
            v-model="powerForm.name"
            placeholder="请输入"
            autocomplete="off"
            clearable
            class="itemWidth"
          ></el-input>
        </el-form-item>
        <el-form-item label="变压器容量:">
          <el-input-number v-model="powerForm.capacity"></el-input-number>
        </el-form-item>
        <el-form-item label="变压器id:">
          <!-- <el-input v-model="powerForm.id" placeholder="请输入" autocomplete="off" clearable  class="itemWidth"></el-input> -->
          <label class="point-name">{{ powerForm.measureName }}</label>
          <label class="btn-point" @click="selectPoint('diglog')"
            >选择测量点</label
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savePower">确 定</el-button>
        <el-button @click="powerShow = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as utils from "@/utils/index.js";
import NkLeftTree from "./NkLeftTree.vue";
import axios from "axios"; // 导入http中创建的axios实例
import NkTable from "@/components/common/NkTable.vue";
export default {
  components: { NkLeftTree, NkTable },
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    //查询百度地址
    var getDress = (keywords) => {
      let subdistrict = keywords ? "1" : "0";
      return axios.get(
        "https://restapi.amap.com/v3/config/district?key=e5da28e274bdb51b8d07c0073ff4ecd6&keywords=" +
          keywords +
          "&subdistrict=" +
          subdistrict +
          "&extensions=base"
      );
    };
    return {
      form: {
        projectName: "",
        voltageGrade: "",
        address: "",
        monitoringStations: "",
        transformerNumber: "",
        measureId: "",
        childrenTransformerList: [],
        departmentList: [],
      },
      address: "",
      showDess: false,
      props: {
        //配置级联选择器
        label: "name",
        children: "districts",
        value: "name",
        expandTrigger: "hover",
        // checkStrictly: true, //建立级联选择器父子间的关联，从而可以选择任意一级
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          let nodes;
          setTimeout(() => {
            getDress(node.label ? node.label : "").then((res) => {
              nodes = res.data.districts[0].districts;
              resolve(nodes);
            });
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          }, 100);
        },
      },
      newForm: {
        address: [],
      },
      options: [],
      columns: [
        {
          label: "#",
          show: true,
          type: "index",
        },
        {
          prop: "name",
          label: "变压器名称",
          show: true,
          align: "left",
        },
        {
          prop: "capacity",
          label: "变压器容量",
          show: true,
          align: "left",
        },
        { prop: "operation", slot: "operation", label: "操作", show: true },
      ],
      powTitle: "新增变压器",
      tableDataDep: [],
      columnsDep: [
        {
          label: "#",
          show: true,
          type: "index",
        },
        {
          prop: "name",
          label: "变压器名称",
          show: true,
          align: "left",
        },
        {
          prop: "capacity",
          label: "变压器容量",
          show: true,
          align: "left",
        },
        { prop: "operation", slot: "operation", label: "操作", show: true },
      ],
      powerForm: {},
      powerShow: false,
      powerIndex: "",
      deportIndex: "",
      baseName: "",
      startTime: "",
      endTime: "",
      param: null,
      selectNodeDialog: false,
      viewTreeIndex: 0,
      viewTree: [],
      leftTreeData: [],
      isViewTreeData: true, //是否可以进行请求下次的视图树数据
    };
  },

  computed: {},
  watch: {
    reportData: {
      handler(newVal, oldVal) {
        this.form = JSON.parse(newVal.params);
        if (!this.form.childrenTransformerList) {
          this.form["childrenTransformerList"] = [];
        }
        if (!this.form.departmentList) {
          this.form["departmentList"] = [];
        }
        this.baseName = newVal.baseName;
        this.startTime = newVal.startTime;
        this.endTime = newVal.endTime;
      },
      deep: true,
    },
  },
  methods: {
    /* 选择地址 */
    selectDess() {
      let vm = this;
      vm.showDess = true;
      vm.getDress().then((res) => {
        vm.options = res.data.districts;
      });
    },
    //查询百度地址
    getDress() {
      return axios.get(
        "https://restapi.amap.com/v3/config/district?key=e5da28e274bdb51b8d07c0073ff4ecd6&keywords=&subdistrict=0&extensions=base"
      );
    },
    /* 地址选择 */
    handler(value) {
      this.form.address = this.newForm.address.join("/");
      this.showDess = false;
    },
    /* 新增变压器 */
    addPower() {
      this.powerForm = {
        name: "",
        capacity: "",
        measureId: "",
      };
      this.powTitle = "新增变压器";
      this.powerShow = true;
    },
    /* 保存变压器 */
    savePower() {
      let childrenTransformerList = JSON.parse(
        JSON.stringify(this.form.childrenTransformerList)
      );
      let departmentList = JSON.parse(JSON.stringify(this.form.departmentList));
      if (this.powTitle == "新增变压器") {
        childrenTransformerList.push(this.powerForm);
      } else if (this.powTitle == "编辑变压器") {
        childrenTransformerList[this.powerIndex] = JSON.parse(
          JSON.stringify(this.powerForm)
        );
      } else if (this.powTitle == "新增部门变压器") {
        departmentList.push(this.powerForm);
        console.log(this.form);
      } else {
        departmentList[this.powerIndex] = JSON.parse(
          JSON.stringify(this.powerForm)
        );
      }
      this.form.childrenTransformerList = childrenTransformerList;
      this.form.departmentList = departmentList;
      this.powerShow = false;
    },
    /* 编辑变压器 */
    editPowerRow(row, i) {
      this.powerForm = JSON.parse(JSON.stringify(row));
      this.powTitle = "编辑变压器";
      this.powerIndex = i;
      this.powerShow = true;
    },
    /* 删除编辑器 */
    removePorweRow(row, i) {
      this.$confirm("是否删除该变压器", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.form.childrenTransformerList.splice(i, 1);
        console.log(this.form.childrenTransformerList);
      });
    },
    /* 新增部门 */
    addDe() {
      this.powerForm = {
        name: "",
        capacity: "",
        measureId: "",
      };
      this.powTitle = "新增部门变压器";
      this.powerShow = true;
    },
    /* 编辑部门 */
    editDeRow(row, i) {
      this.powerForm = JSON.parse(JSON.stringify(row));
      this.powTitle = "编辑部门变压器";
      this.powerIndex = i;
      this.powerShow = true;
    },
    /* 删除部门 */
    removeDeRow(row, i) {
      this.$confirm("是否删除该变压器", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.form.departmentList.splice(i, 1);
      });
    },
    /* 保存 */
    async savePageAllData() {
      let vm = this;
      let res = await vm.$api.nhtj.modifyReportAutomaticGeneratingConfig(
        vm.$store.state.user.currentCompanyId,
        vm.reportData.model,
        vm.reportData.id,
        vm.baseName,
        JSON.stringify(vm.form),
        vm.reportData.loopRegulation,
        vm.startTime,
        vm.endTime,
        vm.reportData.groupId
      );
      console.log(res);
      if (res.success) {
        vm.$message.success(res.msg);
        vm.$emit("savePageAllData", true);
      }
    },
    /* 重置 */
    resetForm() {
      this.form = {
        projectName: "",
        voltageGrade: "",
        address: "",
        monitoringStations: "",
        transformerNumber: "",
        measureId: "",
        childrenTransformerList: [],
        departmentList: [],
      };
    },
    //树加载
    async bindGetTreeTabCode() {
      let vm = this;
      let res = await vm.$api.view.getCompanyViewTreesInfo(
        this.$store.state.user.info.companyId
      );
      if (res.success) {
        vm.viewTree = res.data;
        vm.viewTreeClick(res.data[0], 0);
      }
    },
    /* 选择计量点 */
    selectPoint(param) {
      //选择计量点触发的方法;item:数据源，index:第几个柜,pointIndex:第几个开关
      this.selectNodeDialog = true;
      this.param = param;
      this.bindGetTreeTabCode();
    },
    /* 选择视图节点 */
    async viewTreeClick(item, index) {
      let vm = this;
      if (!vm.isViewTreeData) {
        return;
      }
      vm.viewTreeIndex = index;
      vm.isViewTreeData = false; //避免不断点击，造成疯狂请求
      let result = await vm.$api.view.getViewTreeNodes(item.id);
      vm.isViewTreeData = true;
      if (!result.success) {
        vm.$message.error(result.msg);
        return;
      }
      vm.leftTreeData = utils.creatTreeData(result.data, 0);
    },
    /* 视图树节点点击事件 */
    nodeClick(data) {
      //节点点击
      let vm = this;
      if (vm.param == "diglog") {
        vm.powerForm.measureName = data.label;
        vm.powerForm.measureId = data.id;
      } else {
        vm.form.measureName = data.label;
        vm.form.measureId = data.id;
      }
      vm.selectNodeDialog = false;
    },
  },
};
</script>
<style lang='less' scoped>
.bigBox {
  color: #000;
  width: 100%;
  height: 100%;
  overflow: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  .boxtop {
    font-size: 22px;
    border-bottom: 1px solid #cccc;
    margin-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    padding: 10px 0px;
  }
  .pabox {
    padding: 14px;
    box-sizing: border-box;
  }
  .bRight {
    margin-top: 5px;
    margin-right: 8px;
  }
  .itemWidth {
    width: 250px;
  }
  .sum {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
    width: 100px;
  }
  .page {
    margin-left: 240px;
  }
  .samllBox {
    width: 100%;
    display: flex;
    .item {
      display: flex;
      flex: 1;
      flex-flow: column;
      .top {
        margin-top: 10px;
        height: 250px;
      }
    }
  }
}
.top {
  margin-top: 14px;
  height: 250px;
}
.sumOne {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  width: 124px;
}
.dialog-info {
  display: flex;
  width: 100%;
  height: 300px;
  border: 1px solid #d5dadd;
  .view-tree {
    width: 200px;
    height: 300px;
    border-right: 1px solid #d5dadd;
    overflow-y: auto;
    .view-tree-item {
      line-height: 28px;
      padding: 0 5px;
      box-sizing: border-box;
      border-bottom: 1px dashed #d5dadd;
      cursor: pointer;
      font-size: 14px;
    }
    .view-tree-select {
      background: #d5dadd;
    }
  }
  .dialog-box {
    flex: 1;
    overflow-y: auto;
    padding: 0 5px;
    box-sizing: border-box;
    .tree-warp {
      height: 100%;
    }
  }
}
.btn-point {
  color: #409eff;
  cursor: pointer;
  margin-left: 6px;
}
.bm-item {
  color: #000;
}
.view-tree-select {
  background: #d5dadd;
}
.tobbox {
  padding: 10px;
  box-sizing: border-box;
  .tobboxItem {
    display: flex;
    margin-bottom: 22px;
  }
}
</style>